<template>
  <div class="p-3 row">
    <input-text
      class="col-12 col-md-4"
      label="Versão"
      :disabled="readonly"
      v-model="form.versao"
      ref="versao"
      required
    />
    <input-date-time
      class="col-12 col-md-4"
      label="Data início do projeto"
      :disabled="readonly"
      v-model="form.dataInicio"
      ref=""
      required
    />
    <input-select
      class="col-12"
      label="Tipo de compartilhamento dos resultados"
      :disabled="readonly"
      :options="options.tiposCompatilhamentosResultados"
      v-model="form.compartilhamentoResultado"
      ref="compartilhamento"
      required
    />

    <div class="col-12" v-if="!readonly">
        <b-button v-if="permissao.c" variant="success" @click="$emit('salvar',form)">
            <i class="fa-solid fa-file-code mr-2"></i>
            Gerar XML
        </b-button>
    </div>
    <div class="col-12 mt-3">
        <h6>Lista de XML's Gerados</h6>
        <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
            <template  #cell(actions)="data">
                <div class="d-inline-flex">
                    <b-button variant="flat-primary" class="mr-2" @click="$emit('download', `${data.item.id}`)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                    <b-button variant="flat-danger" v-if="!readonly && permissao.d " class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                </div>
            </template>
        </b-table>
    </div>
    
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputDateTime from "@/components/inputs/InputDateTime";

import helpers from "@/common/utils/helpers";

import { FormMixin } from "@/common/mixins/FormMixin";

// import moment from "moment";

export default {
  name: "Aneel6",
  mixins: [FormMixin],
  props: {
    itens: {
      type: Array, // Defina o tipo como Array
      default: () => [],
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InputText,
    InputSelect,
    InputDateTime,
  },
  data: () => ({
    form: {
      codigoInterno: "",
      versao: 0,
      dataInicio: "",
      compartilhamentoResultado: "",
    },

    table: {
      fields: [
        { key: "nomeArquivoAWS", label: "Nome do arquivo" },
        { key: "versao", label: "Versão" },
        {
          key: "dataCriacao",
          label: "Data de emissão",
          formatter: (value) => helpers.formatarDataBr(value),
        },
        {
          key: "dataInicio",
          label: "Data de início",
          formatter: (value) => helpers.formatarDataBr(value),
        },
        { key: "actions", label: "Ações" },
      ],
    },

    options: {
      tiposCompatilhamentosResultados:
        helpers.getTiposCompatilhamentosResultados(),
    },
  }),
  watch: {
    itens: {
      handler: function (newValue) {        
        this.form.versao = newValue.length
          ? newValue[newValue.length - 1].versao + 1
          : 1;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    readonly: function () {
      return (
        this.$route.name != "projeto-detalhamento" || !this.projetoEditavel
      );
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"](
        "ProjetosPdObrigacoesAneel"
      );
    },
  }
};
</script>
<style lang=""></style>
